import { render, staticRenderFns } from "./TeacherItem.vue?vue&type=template&id=66568d9c&scoped=true&"
import script from "./TeacherItem.vue?vue&type=script&lang=js&"
export * from "./TeacherItem.vue?vue&type=script&lang=js&"
import style0 from "./TeacherItem.vue?vue&type=style&index=0&id=66568d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66568d9c",
  null
  
)

export default component.exports